{
  "invitation.title": "Invite {{teacher_name}}",
  "new.title": "New Invitation",
  "new.description": "Invite directly or start the conversation about joining your team.",
  "new.team_select_placeholder": "Select a team",
  "new.team_select_label": "Team",
  "new.initial_status_label": "Initial Status",
  "new.initial_status.consideration": "Under Consideration",
  "new.initial_status.consideration_description": "Send your contact details to this teacher. They'll be able to get in touch to have a discussion about joining your team.",
  "new.initial_status.ready_to_accept": "Ready to Accept",
  "new.initial_status.ready_to_accept_description": "Send a direct invite to this teacher. They’ll get an email where they can accept and join.",
  "new.message_label": "Message",
  "new.ready_to_accept_pro_forma": "You’re invited to join our teaching team.\nWe’d love to have you involved!",
  "new.consideration_pro_forma": "We’re considering you for our teaching team.\nWe look forward to connecting with you.",
  "invitation_sent": "Invitation sent.",
  "invitation_rejected": "Invitation rejected.",
  "invitation_accepted": "Invitation accepted.",
  "invitation_cancelled": "Invitation cancelled.",
  "invitation_ready_to_accept": "Invitation ready to accept.",
  "response": {
    "new": {
      "title": "Invitation from {{team_profile_name}}",
      "accept": "Accept",
      "reject": "Reject",
      "status_description": {
        "ready_to_accept": "You've been invited to join {{team_profile_name}}. Accept or decline below, or respond to the invitation email to discuss.",
        "consideration": "You've been invited to join {{team_profile_name}}. Reply to the invitation email to discuss next steps.",
        "accepted": "This invitation to {{team_profile_name}} has been accepted",
        "rejected": "This invitation to {{team_profile_name}} has been rejected",
        "cancelled": "this invitation to {{team_profile_name}} has been cancelled"
      },
      "warning": "This decision is permanent and cannot be undone.",
      "accept_info": {
        "heading": "Accept invitation",
        "description": "You'll become a member of the team with full access to shared resources."
      },
      "reject_info": {
        "heading": "Reject invitation",
        "description": "You won't be able to join this team. This action cannot be undone."
      }
    }
  },
  "index": {
    "title": "Active Invitations",
    "empty_list_title": "No Active Invitations",
    "empty_list_description": "Search for teachers to invite to your team.",
    "find": "Find Teachers",
    "profile": "View Profile",
    "actions": {
      "allow_acceptance": "Allow Acceptance",
      "allow_acceptance_description": "An email will be sent to the teacher so they can accept the invitation. Continue?",
      "cancel": "Cancel Invitation",
      "cancel_description": "The teacher will no longer be able to accept this invitation. Continue?"
    },
    "status": {
      "ready_to_accept": "Pending Acceptance",
      "consideration": "Under Consideration"
    }
  }
}
